import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { Empty } from '@/components/ui/EmptyState';
import { IntegrationManagementSettings } from '@/features/integration-management';
import { parseSettingsHash } from '@/features/settings/settings-navigation';
import { INTEGRATION_MANAGEMENT_HASH } from '@/features/settings/settings-search-dom';
import { SettingsSection } from '@/features/settings/settings-section';
import {
  resolveIntegrationProviderDeepLink,
  useSettingsDeepLinkTarget,
} from '@/features/settings/useSettingsDeepLink';
import { tabStore } from '@/features/tabs';
import { Routes } from '@/types/routes';
import { navigate } from '@/utils/navigation-service';

const managementItem = parseSettingsHash(INTEGRATION_MANAGEMENT_HASH)?.item;

export const showsIntegrationManagement = (
  section: string | undefined,
  item: string | undefined
) =>
  section === 'Integrations' &&
  (item === managementItem ||
    resolveIntegrationProviderDeepLink(section, item) !== null);

export const IntegrationSettings = () => {
  const { section, item } = useSettingsDeepLinkTarget();

  if (showsIntegrationManagement(section, item)) {
    return <IntegrationManagementSettings />;
  }

  const openPlugins = () => {
    const pluginsTab = tabStore.tabs.find(
      (tab) => tab.route.path === Routes.Integrations
    );
    pluginsTab
      ? tabStore.activateTab(pluginsTab.id)
      : tabStore.createTab({ path: Routes.Integrations });
    void navigate({ to: Routes.Integrations as string });
  };

  return (
    <SettingsSection.Root>
      <SettingsSection.Header>
        <SettingsSection.Title>Integrations</SettingsSection.Title>
      </SettingsSection.Header>
      <Empty.Root>
        <Empty.Media variant="icon">
          <Icons.puzzle />
        </Empty.Media>
        <Empty.Header>
          <Empty.Title>Integrations have moved</Empty.Title>
          <Empty.Description>
            Manage integrations from the Integrations page.
          </Empty.Description>
        </Empty.Header>
        <Empty.Actions>
          <Button onClick={openPlugins}>Open Integrations</Button>
        </Empty.Actions>
      </Empty.Root>
    </SettingsSection.Root>
  );
};
